<template>
  <div v-if="availability" class="class-availability-details">
    <p data-testid="class-enrolled-count">
      <strong>Enrolled:</strong> {{ enrolledText }}
    </p>
    <p v-if="availability.availableSlots != null">
      <strong>Available slots:</strong> {{ availability.availableSlots }}
    </p>
    <p v-if="isStaff" data-testid="class-waitlist-count">
      <strong>Waitlist:</strong> {{ availability.waitlisted ?? 0 }}
    </p>
    <template v-if="staggers.length">
      <p><strong>Signups open:</strong></p>
      <p
        v-for="stagger in staggers"
        :key="stagger.staggerDate.getTime()"
        :class="{ 'text-medium-emphasis': stagger.staggerDate > now }"
        data-testid="class-stagger"
      >
        {{ formatDateNY(stagger.staggerDate) }}
        {{ formatTimeNY(stagger.staggerDate) }} - {{ stagger.occupancy }} slot{{
          stagger.occupancy === 1 ? "" : "s"
        }}
        ({{ stagger.occupiedSlots }} taken)
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { ClassAvailability } from "../../../cbi-generator/generated/dto/ClassAvailability";
import { useEnv } from "@/composables/useEnv";
import { useUtility } from "@/composables/useUtility";

const props = defineProps<{ availability: ClassAvailability | null }>();

const { formatDateNY, formatTimeNY } = useUtility();
const isStaff = useEnv().mode == "STAFF";
const now = new Date();

const staggers = computed(() =>
  (props.availability?.staggers ?? []).map((s) => ({
    ...s,
    staggerDate: new Date(s.staggerDate),
  })),
);

// Enrolled out of the slots released so far; uncapped/override classes report no total.
const enrolledText = computed(() => {
  const enrolled = props.availability?.enrolled ?? 0;
  const total = props.availability?.totalSlots;
  return total != null ? `${enrolled}/${total}` : `${enrolled}`;
});
</script>
